import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog"]

  disconnect() {
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget) return

    this.dialogTarget.hidden = false
    document.body.classList.add("overflow-hidden")
    this.dialogTarget.querySelector("[data-close]")?.focus()
  }

  close(event) {
    if (!this.hasDialogTarget || this.dialogTarget.hidden) return

    event?.preventDefault()
    this.dialogTarget.hidden = true
    document.body.classList.remove("overflow-hidden")
  }

  backdrop(event) {
    if (event.target !== event.currentTarget) return
    this.close(event)
  }
}
